import { Http } from '@/model/Http.js'

export default class commission extends Http {
  //佣金提现列表
  getCommList(data){
    const url = 'api/user-withdraw-audit/search'
    return this.postAjax(url, {
       ...data
    })
  }

  //驳回
  rejectWithdraw(data){
    const url='api/user-withdraw-audit/reject'
    return this.postAjax(url, {
      ...data
    })
  }

  //仅审核不打款
  auditWithdraw(data){
    const url='api/user-withdraw-audit/update-state'
    return this.postAjax(url, {
      ...data
    })
  }

  //打款
  remitWithdraw(data){
    const url='api/user-withdraw-audit/transfer'
    return this.postAjax(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/commission.js